import './index.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { FeatureFlagsProvider } from 'context/featureFlag';
import HooksProvider from 'providers';
import MatrixProvider from 'providers/Matrix';
import OrganizationProvider from 'providers/Organization';
import { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from 'redux/main';
import OkrProvider from '_revamp/context/okr';
import fallbackLogo from 'assets/img/vert_trans.png';
import App from './App';
import './helpers/multilanguage';
import reportWebVitals from './reportWebVitals';
import 'react-tooltip/dist/react-tooltip.css';

function SuspenseFallback() {
  return (
    <div className="suspense-fallback-page">
      <img className="suspense-fallback-logo" src={fallbackLogo} alt="Rize" />
      <div className="suspense-progress-wrapper">
        <div className="suspense-progress-bar" />
      </div>
    </div>
  );
}

const noopLogger = () => undefined;

if (['https://api.betterandco.com/', 'https://dev.betterandco.com/'].includes(window.location.origin)) {
  globalThis.console.log = noopLogger;
  globalThis.console.error = noopLogger;
  globalThis.console.debug = noopLogger;
}
const queryClient = new QueryClient();
const rootElement = document.getElementById('root');
type LegacyReactDom = {
  render: typeof ReactDOM.render;
};

const renderApp = (ReactDOM as unknown as LegacyReactDom).render;

if (rootElement) {
  renderApp(
    <FeatureFlagsProvider>
      <Suspense fallback={<SuspenseFallback />}>
        <Provider store={store}>
          <HooksProvider>
            <OrganizationProvider>
              <MatrixProvider>
                <OkrProvider>
                  <QueryClientProvider client={queryClient}>
                    <App />
                  </QueryClientProvider>
                </OkrProvider>
              </MatrixProvider>
            </OrganizationProvider>
          </HooksProvider>
        </Provider>
      </Suspense>
    </FeatureFlagsProvider>,
    rootElement,
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
